import React from 'react';
import LandingPage from './pages/LandingPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AppLayout from './layout/AppLayout';
import { Toaster } from 'react-hot-toast';

// ========== IMPORTS DE TOUTES TES PAGES ==========
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import UsersPage from './pages/UsersPage';
import LeadsPage from './pages/LeadsPage';
import CampaignsPage from './pages/CampaignsPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import CampaignFilesPage from './pages/CampaignFilesPage';
import ImportedLeadsPage from './pages/ImportedLeadsPage';
import CallsPage from './pages/CallsPage';
import DealsPage from './pages/DealsPage';
import CompaniesPage from './pages/CompaniesPage';
import InvoicesPage from './pages/InvoicesPage';
import PartnersPage from './pages/PartnersPage';
import TasksPage from './pages/TasksPage';
import StockItemsPage from './pages/StockItemsPage';
import CompanyPartnershipsPage from './pages/CompanyPartnershipsPage';
import ProfilesPage from './pages/ProfilesPage';
import ProjectsPage from './pages/ProjectsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ReportsPage from './pages/ReportsPage';
import CalendarPage from './pages/CalendarPage';
import PipelinePage from './pages/PipelinePage';
import IntegrationsPage from './pages/IntegrationsPage';
import Settings from './pages/Settings';
import AppSettingsPage from './pages/AppSettings';
import GlobalSettingsPage from './pages/GlobalSettings';
import RolesPage from './pages/RolesPage';
import LogsPage from './pages/LogsPage';
import PermissionsPage from './pages/PermissionsPage';
import ListDetailPage from './pages/ListDetailPage';
import AgentCampaignsPage from './pages/AgentCampaignsPage';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <Routes>
            {/* PAGE PUBLIQUE */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<LandingPage />} />
            
            {/* TOUTES LES PAGES PROTÉGÉES AVEC LE NOUVEAU LAYOUT */}
            <Route
              path="/*"
              element={
                <AppLayout>
                  <Routes>
                    {/* Redirection */}
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    
                    {/* ========== TOUTES TES ROUTES ========== */}
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/leads" element={<LeadsPage />} />
                    <Route path="/campaigns" element={<CampaignsPage />} />
                    <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
                    <Route path="/campaigns/:id/files" element={<CampaignFilesPage />} />
                    <Route path="/campaigns/:campaignId/files/:fileId/leads" element={<ImportedLeadsPage />} />
                    <Route path="/calls" element={<CallsPage />} />
                    <Route path="/deals" element={<DealsPage />} />
                    <Route path="/companies" element={<CompaniesPage />} />
                    <Route path="/invoices" element={<InvoicesPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/tasks" element={<TasksPage />} />
                    <Route path="/stock_items" element={<StockItemsPage />} />
                    <Route path="/company_partnerships" element={<CompanyPartnershipsPage />} />
                    <Route path="/profiles" element={<ProfilesPage />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/pipeline" element={<PipelinePage />} />
                    <Route path="/integrations" element={<IntegrationsPage />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/app-settings" element={<AppSettingsPage />} />
                    <Route path="/global-settings" element={<GlobalSettingsPage />} />
                    <Route path="/roles" element={<RolesPage />} />
                    <Route path="/logs" element={<LogsPage />} />
                    <Route path="/permissions" element={<PermissionsPage />} />
                    <Route path="/list/:id" element={<ListDetailPage />} />
                    <Route path="/agent-campaigns" element={<AgentCampaignsPage />} />
                    
                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </AppLayout>
              }
            />
          </Routes>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#1f2937',
                color: '#fff',
                borderRadius: '12px',
              },
            }}
          />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;

